<template>
  <div
    id="main-screenshot"
    class="screenshot"
  >
    <div class="content">
      <canvas
        id="clip-canvas"
        :width="srcUrl ? vWidth : 0"
        :height="srcUrl ? vHeight : 0"
      ></canvas>
      <div :style="'height:' + topHeight">
        <video
          id="screenshot-video"
          crossorigin="anonymous"
          width="100%"
          height="100%"
          :src="srcUrl"
          :muted="isMuted"
        ></video>
      </div>
    </div>
    <div
      id="operate-area-id"
      class="operate-area"
    >
      <!--1-->
      <div class="play-area">
        <input
          id="screenshot-input"
          type="file"
          style="display:none;"
          @change="changeFile"
        >
        <label
          id="select-btn"
          @click="selectChangeFile"
        >
          <span class="text">替换视频</span>
        </label>
        <div class="mid">
          <div class="play-btn">
            <div
              v-if="!isPlaying"
              class="play"
              @click="play()"
            >
              <iconfont
                class="play-icon"
                style="font-size:15px;"
                name="#icon11-11zantingbofanganniu"
              ></iconfont>
            </div>
            <div
              v-if="isPlaying"
              class="pause"
              @click="pause()"
            >
              <iconfont
                class="play-icon"
                style="font-size:15px;"
                name="#icon11-12bofanganniu"
              ></iconfont>
            </div>
          </div>
          <div class="dur">
            {{ currString }}/{{ durString }}
          </div>
        </div>

        <div class="volume">
          <div
            v-if="!isMuted"
            class="yes"
            @click="clickMuted"
          >
            <iconfont
              style="font-size:15px;"
              name="#icon11-13yinlianganniu"
            ></iconfont>
          </div>
          <div
            v-if="isMuted"
            class="no"
            @click="clickMuted"
          >
            <iconfont
              style="font-size:15px;"
              name="#icon11-14yinliangjingyinanniu"
            ></iconfont>
          </div>
        </div>
      </div>
      <!--2-->
      <div class="time-area">
        <div id="ss-time-line">
          <!-- <div class="track">
            <div
              class="move"
              :style="{left: current*100/duration+'%'}"
              @mousedown="moveDrag" @mousedown="moveDrag"
            ></div>
          </div>-->
          <el-slider
            v-if="srcUrl"
            v-model="current"
            style="height:30px"
            :max="duration"
            :show-tooltip="false"
            :step="0.1"
            @input="dragInput"
          ></el-slider>
        </div>
      </div>
      <!--3-->
      <div class="clip-area">
        <span class="text1">调整时间</span>
        <formatTimeInput
          :pri-time="current"
          @blur="limitChange"
          @focus="pause"
          @mousedown="pause"
        ></formatTimeInput>
        <span class="text2">图片格式</span>
        <div class="down-list">
          <!-- <dropDownMenu
            v-model="selectedOutput"
            :menu-list="outputTypes"
          ></dropDownMenu> -->
          <el-select
            v-model="selectedOutput"
            class="screenshot-el-select"
            placeholder="请选择"
            popper-class="screenshot-el-popper"
          >
            <el-option
              v-for="item in outputTypes"
              :key="item"
              style="color:#333;font-weight:normal;font-family:Microsoft YaHei;"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div
          class="clip-btn"
          @click="clip"
        >
          截图
        </div>
      </div>
    </div>
    <div
      v-if="!srcUrl"
      class="blank-page"
    >
      <blankAdd
        class="blank-add"
        @changeFiles="changeFile"
      ></blankAdd>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'; //mapActions
import blankAdd from '@/components/global/blankAdd.vue';
import formatTimeInput from '@/components/videoCutter/formatTimeInput.vue';
//import dropDownMenu from '@/components/videoConverter/dropDownMenu.vue'; dropDownMenu

export default {
  name: 'Screenshot',
  components: { blankAdd, formatTimeInput },
  props: {},
  data() {
    return {
      srcUrl: null,
      mainEle: null,
      operateEle: null,
      videoEle: null,
      canvasEle: null,
      canvasCtx: null,
      vWidth: 0,
      vHeight: 0,
      isMuted: false,
      isPlaying: false,
      current: 0,
      duration: 10,
      dx: 0,
      isDrag: false,
      filename: '',
      topHeight: 0,
      selectedOutput: 'png',
      outputTypes: ['png', 'jpeg'],
      startCutting: false,
      videoSize: 0,
      fileType: -1,
      fromOther: false
    };
  },
  computed: {
    ...mapGetters({
      clipImages: 'screenshot/clipImages'
    }),
    durString() {
      return (
        parseInt(this.duration / 60)
          .toString()
          .padStart(2, 0) +
        ':' +
        parseInt(this.duration % 60)
          .toString()
          .padStart(2, 0)
      );
    },
    currString() {
      return (
        parseInt(this.current / 60)
          .toString()
          .padStart(2, 0) +
        ':' +
        parseInt(this.current % 60)
          .toString()
          .padStart(2, 0)
      );
    }
  },
  created() {
    this.$bus.on('changeFiles', this.changeFile);
  },

  mounted() {
    this.mainEle = document.getElementById('main-screenshot');
    this.operateEle = document.getElementById('operate-area-id');
    this.canvasEle = document.getElementById('clip-canvas');
    if (this.canvasEle) {
      this.canvasCtx = this.canvasEle.getContext('2d');
    }

    // let input = document.getElementById('screenshot-input');
    // let fileBtn = document.getElementById('select-btn');
    // fileBtn.addEventListener('click', function() {
    //   input.click();
    // });
    let video = document.getElementById('screenshot-video');
    let _this = this;
    _this.videoEle = video;
    video.onerror = function(e) {
      console.log('onerror', e);
      _this.srcUrl = '';
      _this.filename = '';
    };
    video.addEventListener('loadedmetadata', function(e) {
      //console.log('loadedmetadata', e, e.target.webkitVideoDecodedByteCount);
      if (e.target.videoWidth < 1) {
        _this.srcUrl = '';
        _this.$message.error('格式不支持');
      } else {
        _this.$store.commit('common/setEditing', true);
        _this.vWidth = e.target.videoWidth;
        _this.vHeight = e.target.videoHeight;
        _this.duration = e.target.duration;
        _this.current = 0;
        _this.pause();
        //神策
        if (!_this.srcUrl.startsWith('https://resources.laihua.com')) {
          _this.$sensors.track('toolVideoUpload', {
            tool_type: '截图宝',
            video_source: _this.fromOther ? '其他工具' : '本地上传',
            video_duration: _this.duration,
            video_size: _this.videoSize
          });
        } else {
          let v_s = _this.fromOther ? '其他工具' : '本地上传';
          if (_this.fileType === 27) v_s = '作品库';
          if (_this.fileType === 26) v_s = '视频库';
          _this.$sensors.track('toolVideoUpload', {
            tool_type: '截图宝',
            video_source: v_s,
            video_duration: _this.duration,
            video_size: _this.videoSize
          });
        }
      }
    });
    // video.addEventListener('loadeddata', function(e) {
    //   console.log('loadeddata', e, e.target.webkitVideoDecodedByteCount);
    //   //webkitVideoDecodedByteCount
    // });
    video.addEventListener('timeupdate', function(e) {
      _this.current = e.target.currentTime;
    });
    video.addEventListener('ended', function() {
      _this.pause();
      _this.current = 0;
    });
    window.addEventListener('mousedown', this.moveDrag);
    window.addEventListener('resize', this.changeSize);

    if (this.$route.query.pipe === '1') {
      this.fromOther = true;
      let data = this.$store.getters['completed/getPipeFiles'];
      if (data.length) {
        this.fileType = -1;
        let one = data[0];
        if (one.file) {
          this.filename = one.name.split('.')[0];
          this.srcUrl = window.URL.createObjectURL(one.file);
          //神策
          this.videoSize = one.file.size / 1024.0 / 1024;
          this.$nextTick(() => {
            this.changeSize();
          });
        } else if (one.url) {
          this.filename = one.name.split('.')[0];
          this.srcUrl = this.$.handleAssetsUrl(one.url);
          this.$store.commit('uploader/setVideoUrl', one.url);
          //神策
          this.videoSize = one.size / 1024.0 / 1024;
          this.$nextTick(() => {
            this.changeSize();
          });
        }
      }
    }

    // let query = this.$route.query;
    // if (query.pipe === '1') {
    //   let data = this.$store.getters['completed/getFiles'];
    //   if (data) {
    //     this.addVideoFromWeb(data);
    //   }
    // }

    let shot = this.$store.getters['uploader/videoUrlShot'];
    if (shot.url && !(this.$route.query || {}).id && !(this.$route.query || {}).pipe) {
      this.changeFile(shot);
    }
  },
  beforeDestroy() {
    this.$bus.off('changeFiles', this.changeFile);
    this.srcUrl = '';
  },
  methods: {
    changeSize() {
      if (!this.srcUrl) return;
      //console.log('changeSize', this.operateEle.offsetHeight, this.mainEle.offsetHeight);
      let top = this.mainEle.offsetHeight - 276;
      this.topHeight = top + 'px';
    },
    clip() {
      if (this.startCutting) return;
      this.startCutting = true;
      setTimeout(() => {
        this.startCutting = false;
      }, 800);
      if (this.srcUrl) {
        this.canvasCtx.drawImage(this.videoEle, 0, 0);
        this.canvasEle.toBlob((blob) => {
          let obj = {
            blob,
            name: this.filename + `[${this.currString}].${this.selectedOutput}`
          };
          this.$store.commit('screenshot/addClipImages', obj);
        }, 'image/' + this.selectedOutput);
        //神策
        let v_s = '其他工具';
        if (this.fileType === 27) v_s = '作品库';
        if (this.fileType === 26) v_s = '视频库';
        this.$sensors.track('toolVideoProcess', {
          tool_type: '截图宝',
          video_source: v_s
        });
      }
    },
    moveDrag(e) {
      let className = e.target.className.toString();
      if (
        className.startsWith('el-tooltip el-slider__button') ||
        className.startsWith('el-slider__runway') ||
        className.startsWith('el-slider__bar')
      ) {
        this.pause();
        //console.log('moveDrag2', e.target.className);
      }
    },
    dragInput(e) {
      //console.log('dragInput', e);
      if (!this.isPlaying) {
        this.videoEle.currentTime = e;
      }
    },
    limitChange(e) {
      this.current = e.val;
    },
    play() {
      if (!this.srcUrl) return;
      this.isPlaying = true;
      this.videoEle.play();
    },
    pause() {
      this.isPlaying = false;
      this.videoEle.pause();
    },
    clickMuted() {
      this.isMuted = !this.isMuted;
    },
    selectChangeFile() {
      this.pause();
      this.$modal.show('selectModal', {
        tips: this.$route.path === 'screenshot' ? '支持格式：MP4 ' : undefined,
        isUpload: false,
        onFile: (file) => {
          this.changeFile({
            name: file.name,
            blob: file
          });
          this.$modal.hide('selectModal');
          this.fromOther = false;
        },
        onUrl: (url) => {
          url;
          this.fromOther = false;
        }, // 文件全送到云端时回调
        onInfo: (info) => {
          this.changeFile({
            name: info.title,
            url: info.url,
            duraton: info.duration,
            size: info.size,
            fileType: info.fileType
          });
          this.$route.query.pipe = '0';
          //console.log('onInfo info info', info);
          this.$modal.hide('selectModal');
        }
      });
    },
    changeFile(file) {
      //console.log('changeFile', file.blob, window.URL.createObjectURL);
      if (file.blob) {
        this.filename = file.name.split('.')[0];
        this.srcUrl = window.URL.createObjectURL(file.blob);
        //神策
        this.videoSize = file.blob.size / 1024.0 / 1024;
        this.fromOther = false;
        this.fileType = -1;
        this.$nextTick(() => {
          this.changeSize();
        });
      } else if (file.url) {
        this.filename = file.name.split('.')[0];
        this.srcUrl = this.$.handleAssetsUrl(file.url);
        //神策
        this.videoSize = (file.size || 0) / 1024.0 / 1024;
        this.fileType = file.fileType;
        this.fromOther = false;
        this.$nextTick(() => {
          this.changeSize();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.screenshot {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f6f7fb;
  .blank-page {
    position: absolute;
    background-color: #f6f7fb;
    width: 100%;
    height: 100%;
    padding: 17px 65px 54px 74px;
  }
  .content {
    position: relative;
    height: 100%;
    margin: 17px 65px 0 74px;
    background-color: white;
    #clip-canvas {
      position: absolute;
      display: none;
    }
  }
  .operate-area {
    // background-color: aqua;
    height: 276px;
    margin: 0 65px 0 74px;
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    .play-area {
      margin: 30px 0 0 0;
      width: 100%;
      height: 50px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      #select-btn {
        width: 92px;
        height: 30px;
        background: #ffffff;
        border: 1px solid #ffffff;
        box-shadow: 1px 2px 5px 0px rgba(124, 124, 124, 0.13);
        border-radius: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        .text {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #343434;
        }
        &:hover {
          cursor: pointer;
          border: 1px solid #2f58fe;
          .text {
            color: #2f58fe;
          }
        }

        @media (max-width: 1600px) {
          width: 80px;
          height: 26px;
          border-radius: 13px;
          .text {
            font-size: 12px;
          }
        }
      }
      .mid {
        display: flex;
        flex-direction: row;
        align-items: center;
        .play-btn {
          &:hover {
            cursor: pointer;
          }
          .play {
            width: 50px;
            height: 50px;
            background: #ffffff;
            box-shadow: 1px 2px 5px 0px rgba(124, 124, 124, 0.13);
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #2f58fe;
            .play-icon {
              font-size: 15px;
            }
          }
          .pause {
            width: 50px;
            height: 50px;
            background: #ffffff;
            box-shadow: 1px 2px 5px 0px rgba(124, 124, 124, 0.13);
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #2f58fe;
          }
          @media (max-width: 1600px) {
            .play {
              width: 36px;
              height: 36px;
              > svg {
                margin-left: 1px;
                transform-origin: center;
                transform: scale(0.8);
              }
            }
            .pause {
              width: 36px;
              height: 36px;
              > svg {
                margin-left: 1px;
                transform-origin: center;
                transform: scale(0.8);
              }
            }
          }
        }
        .dur {
          margin: 0 0 0 18px;
          height: 50px;
          line-height: 50px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #343434;
          @media (max-width: 1600px) {
            font-size: 12px;
            margin: 0 0 0 10px;
          }
        }
      }
      .volume {
        width: 30px;
        height: 30px;
        &:hover {
          cursor: pointer;
        }
        .yes {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 30px;
          height: 30px;
          background: #ffffff;
          border: 1px solid #ffffff;
          box-shadow: 1px 2px 5px 0px rgba(124, 124, 124, 0.13);
          border-radius: 15px;
          color: #2f58fe;
        }
        .no {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 30px;
          height: 30px;
          background: #ffffff;
          border: 1px solid #ffffff;
          box-shadow: 1px 2px 5px 0px rgba(124, 124, 124, 0.13);
          border-radius: 15px;
          color: #2f58fe;
        }
        @media (max-width: 1600px) {
          width: 26px;
          height: 26px;
          .yes {
            width: 26px;
            height: 26px;
            border-radius: 13px;
            > svg {
              transform-origin: center;
              transform: scale(0.8);
            }
          }
          .no {
            width: 26px;
            height: 26px;
            border-radius: 13px;
            > svg {
              transform-origin: center;
              transform: scale(0.8);
            }
          }
        }
      }
    }
    .time-area {
      margin: 30px 0 0 0;
      width: 100%;
      height: 60px;
      #ss-time-line {
        height: 60px;
        position: relative;
        /deep/ .el-slider__button {
          margin: 3px 0 0 0;
          width: 30px;
          height: 30px;
          border-radius: 15px;
          border: 0px !important;
          box-shadow: 0px 5px 30px 0px rgba(22, 64, 234, 0.16);
        }
        /deep/ .el-slider__runway {
          height: 10px;
          border-radius: 5px;
          .el-slider__bar {
            height: 10px;
            border-radius: 5px;
            background: #2f58fe;
          }
        }
        // .track {
        //   position: absolute;
        //   top: 10px;
        //   width: 100%;
        //   height: 20px;
        //   background-color: darkcyan;
        //   .move {
        //     left: 50%;
        //     position: absolute;
        //     margin-left: -5px;
        //     background-color: black;
        //     width: 10px;
        //     height: 20px;
        //   }
        // }
      }
    }
    .clip-area {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      font-size: 16px;
      @media (max-width: 1600px) {
        font-size: 14px;
      }
      .text1 {
        margin: 0 11px 0 0;
        height: 40px;
        line-height: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #343434;
        @media (max-width: 1600px) {
          height: 30px;
          line-height: 30px;
          margin: 0 6px 0 0;
        }
      }
      .text2 {
        margin: 0 10px 0 26px;
        height: 40px;
        line-height: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #343434;
        @media (max-width: 1600px) {
          height: 30px;
          line-height: 30px;
        }
      }
      .down-list {
        width: 120px;
        height: 40px;
        /deep/ .el-select__caret {
          font-size: 8px;
          color: #333;
        }
        @media (max-width: 1600px) {
          width: 84px;
          height: 30px;
          /deep/ .el-input__inner {
            height: 30px;
            line-height: 30px;
            font-size: 12px;
          }
          /deep/ .el-input__icon {
            line-height: 30px;
          }
          /deep/ .el-input__suffix {
            transform-origin: center;
            transform: scale(0.8);
          }
        }
      }
      .clip-btn {
        margin: 0 0 0 60px;
        width: 120px;
        height: 40px;
        line-height: 40px;
        background: #2f58fe;
        border-radius: 4px;
        color: #fff;
        cursor: pointer;
        &:hover {
          background-color: #3d7dff;
        }
        @media (max-width: 1600px) {
          font-size: 12px;
          width: 84px;
          height: 30px;
          line-height: 30px;
          margin: 0 0 0 31px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.el-select-dropdown.el-popper.screenshot-el-popper {
  margin-bottom: 3px;
  /deep/ .popper__arrow {
    display: none;
  }
}
</style>
